import { render, staticRenderFns } from "./AddGift.vue?vue&type=template&id=2f13f530&scoped=true&"
import script from "./AddGift.vue?vue&type=script&lang=js&"
export * from "./AddGift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f13f530",
  null
  
)

export default component.exports